export default __webpack_public_path__ + "bml-documentdb0090.png";